import React, { useState, useMemo, useEffect } from 'react';
import { apiHolder, apis, getIn18Text, isEdm } from 'api';
import { useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import { isMainAccount } from '../../util';
import useState2RM from '../../hooks/useState2ReduxMock';
import { FLOLDER } from '../../common/constant';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import styles from './index.module.scss';
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const PaidGuideTip = () => {
    const [selectedKeys] = useState2RM('selectedKeys', 'doUpdateSelectedKey');
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const [visibleAdmin, setVisibleAdmin] = useState(false);
    const paidGuideModal = useNiceModal('paidGuide');
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const paidGuideTab = useMemo(() => !isEdm() && selectedKeys.id == FLOLDER.SENT && !mailSearching && isMainAccount(selectedKeys.accountId) && productVersionId === 'free', [selectedKeys, mailSearching, productVersionId]);
    useEffect(() => {
        accountApi.doGetAccountIsAdmin().then(res => setVisibleAdmin(res));
    }, []);
    useEffect(() => {
        if (paidGuideTab) {
            trackApi.track('pcMail_show_outbox_free', { type: visibleAdmin ? '管理员' : '成员' });
        }
    }, [paidGuideTab]);
    const tipClick = () => {
        trackApi.track('pcMail_click_outbox_free', { type: visibleAdmin ? '管理员' : '成员' });
        paidGuideModal.show({ errType: '1', origin: '发件箱' });
    };
    if (!paidGuideTab) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: styles.paidTip, onClick: tipClick },
        React.createElement("p", { className: styles.tipTitle },
            getIn18Text('MEIRIKEWAIFAYJFS'),
            "\uFF1A100"),
        React.createElement("p", { className: styles.linkBtn }, getIn18Text('TIGAOFAXINSHANGX'))));
};
export default PaidGuideTip;
